/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react';
import { OrdenesPagoGet } from '../service/ordenesPago';

export default function useUsers() {
    // Estado de carga del listado: los servicios Add/Update/Delete ya movían
    // State.loading, pero el GET no, y las tablas no tenían cómo saber que
    // todavía estaban esperando datos.
    const [cargando, setCargando] = useState(false);

    const [Ordenes, setOrdenes] = useState([]);
    const [State, setState] = useState({ loading: false, error: false, message: '', success: false });

    const OrdenesPagoGetService = useCallback((user_id, token) => {
        setCargando(true);
        OrdenesPagoGet(user_id, token).then(response => {
            setOrdenes(response)
        }).finally(() => setCargando(false))
    }, []);

    return {
        loading: State.loading || cargando,
        error: State.error,
        message: State.message,
        success: State.success,
        Ordenes,
        OrdenesPagoGetService,
    }
}